/** First name from a display name; null-safe. */
export function firstNameOf(displayName: string | null | undefined): string | null {
  const first = displayName?.trim().split(/\s+/)[0];
  return first && first.length > 0 ? first : null;
}

/** "Jack Collins" → "JC"; one word gives one letter; nothing gives "?". */
export function initialsOf(name: string | null | undefined, email?: string | null): string {
  const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0]![0]}${words[words.length - 1]![0]}`.toUpperCase();
  const source = words[0] ?? (email ?? "").trim();
  return source ? source[0]!.toUpperCase() : "?";
}
